/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Style Imports
 */
import {
  StyledLegendDataText,
  StyledLegendLabel,
  StyledLegendList,
  StyledLegendListItem,
  StyledLegendListCont,
  StyledLegendSquare
} from './ChartLegend.styles';

// Type def for custom props
interface LegendProps {
  completeCount: number;
  completePercent: number;
  todoCount: number;
  todoPercent: number;
}

// Chart Legend for Census data
const ChartLegend: FC<LegendProps> = ({
  completeCount,
  completePercent,
  todoCount,
  todoPercent
}) => {
  const { pathname } = window.location;

  return (
    <StyledLegendList id="Pie-Chart-Legend" unit="group">
      <StyledLegendListItem
        id="Completed-Pie-Chart-Item"
        interactive={false}
        unit="item"
      >
        <StyledLegendListCont>
          <StyledLegendSquare color="#00558C" />
          <StyledLegendLabel
            id="Completed-Pie-Chart-Label"
            data-testid="completed-pie-chart-label"
          >
            {pathname.includes('summary') ? 'Rounded' : 'Completed'}
            <StyledLegendDataText>
              {completePercent}% ({completeCount})
            </StyledLegendDataText>
          </StyledLegendLabel>
        </StyledLegendListCont>
      </StyledLegendListItem>
      <StyledLegendListItem
        id="ToDo-Pie-Chart-Item"
        interactive={false}
        unit="item"
      >
        <StyledLegendListCont>
          <StyledLegendSquare color="#E05929" />
          <StyledLegendLabel
            id="ToDo-Pie-Chart-Label"
            data-testid="todo-pie-chart-label"
          >
            {pathname.includes('summary') ? 'Not Rounded' : 'To Do'}
            <StyledLegendDataText>
              {todoPercent}% ({todoCount})
            </StyledLegendDataText>
          </StyledLegendLabel>
        </StyledLegendListCont>
      </StyledLegendListItem>
      {/* ******************************************* */}
      {/* ********* Removing till Phase II ********** */}
      {/* ******************************************* */}
      {/* {!pathname.includes('/employees') && (
        <StyledLegendListItem id="Unable-Pie-Chart-Item">
          <StyledLegendListCont>
            <StyledLegendSquare color="#279BBB" />
            <StyledLegendLabel id="Unable-Pie-Chart-Label">
              Unable to Round
              <StyledLegendDataText>
                {sumData(data) !== 0
                  ? Math.round((100 * data[2]) / sumData(data))
                  : 0}
                % ({data[2]})
              </StyledLegendDataText>
            </StyledLegendLabel>
          </StyledLegendListCont>
        </StyledLegendListItem>
      )} */}
    </StyledLegendList>
  );
};

export default ChartLegend;
